module.exports = __webpack_public_path__ + "fonts/Inter-Light-slnt=0.6ffbefc6.ttf";